















































































































import {Component, Prop, Provide, Vue} from 'vue-property-decorator';
import SelectNodeField from '@c/controls/selectControls/SelectNodeField.vue';
import {PModuleTableHeader, DtcpEmulatorModule} from '@/views/system/modules/interfaces';
import PModuleMeasurementEditDialog from '@v/system/modules/forms/PModuleMeasurementEditDialog.vue';
import Table from '@c/tables/Table.vue';
import TableCheckBox from '@c/tables/TableCheckBox.vue';
import {PModuleMeasurementStore} from '@/views/system/modules/forms/pModuleMeasurementStore';
import IconButton from '@c/controls/IconButton.vue';
import CancelChangesDialog from '@c/CancelChangesDialog.vue';
import router from '@/router';
import measurementsStoreModule from '@/store/modules/entities/measurementsModule';
import {updateMeasurements} from '../../moduleUtils';
import {httpClient} from '@api/baseApi';
import PModuleButtons from './../../../nodes/PModuleButtons.vue';
import nodeModule from '@/store/modules/entities/nodeModule';
import EmulatorModulesTable from './EmulatorModulesTable.vue';
import {PModuleType} from '@/enums/configs';

@Component({
  components: {
    Table,
    TableCheckBox,
    SelectNodeField,
    PModuleMeasurementEditDialog,
    IconButton,
    CancelChangesDialog,
    PModuleButtons,
    EmulatorModulesTable,
  },
})
export default class DtcpEmulatorModuleForm extends Vue {
  loading = false;
  saving = false;

  valid = true;

  measurementDialog = PModuleMeasurementEditDialog;

  @Provide()
  @Prop({required: true})
  pmodule!: DtcpEmulatorModule;

  am: any = [];

  get measurementsStore() {
    return new PModuleMeasurementStore(this.pmodule);
  }

  get temperatureModulesFilter() {
    return PModuleType.DtcpTemperatureModule;
  }

  get energyModulesFilter() {
    return PModuleType.DtcpEnergyModule;
  }

  get tahoModulesFilter() {
    return PModuleType.DtcpTahoModule;
  }

  get accelerometerModulesFilter() {
    return PModuleType.DtcpAccelerometerModule;
  }

  measurementsHeaders: PModuleTableHeader[] = [
    {
      text: 'Измерение',
      value: 'measurementDescription',
      sortable: false,
    },
    {
      text: 'В. гр. предупреждения',
      value: 'topWarningBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. опасного значения',
      value: 'topDangerBoundary',
      sortable: false,
    },
    {
      text: 'В. гр. ошибки',
      value: 'topErrorBoundary',
      sortable: false,
    },
  ];

  nonEmptyTextRule = (v: any) => !!v || (v && v.length === 0) || 'Поле обязательно для заполнения';

  async onSave() {
    this.pmodule.measurements = this.pmodule.measurements.filter((x: any) => x.isActive === true);

    this.valid = await (this.$refs.form as any).validate();

    if (!this.valid) {
      const error = document.querySelector('div.error--text');
      error && this.$vuetify.goTo(error as HTMLElement);
      return;
    }

    this.$emit('save');
  }

  //переменная, сигнализирующая о внесенных и несохраненных изменениях на форме
  changed = false;

  nodeName: any = null;

  // Действия при изменении поля
  async onChange() {
    this.changed = true;
  }

  amFieldClick() {
    router.push(`/hardware/${this.am.id}`);
  }

  nodeFieldClick(index: number) {
    router.push(`/nodes/${this.pmodule.nodes ? this.pmodule.nodes[index].node_id : 0}`); //TODO: fix it?
  }

  async loadAM() {
    if (!this.pmodule.guid) {
      // выходим если это новый ПМ
      return;
    }

    const {data} = await httpClient.get(`modules/`, {
      params: {
        guids: JSON.stringify([this.pmodule.guid]),
      },
    });
    const amId = data[0].hw_pm;
    if (amId != null) {
      const {data} = await httpClient.get<[]>(`hardware/${amId}`);
      this.am = data;
    }
  }

  async loadMeasurements() {
    // Подгружаем список измерений, ещё не использованных в таблице
    await measurementsStoreModule.fetchAll();
    if (this.pmodule.measurements) {
      const newEntities = measurementsStoreModule.entities.filter(
        (x: any) =>
          x.moduleType === this.pmodule.type &&
          !this.pmodule.measurements.some((y: any) => y.measurementId == x.id),
      );
      // если такие измерения найдены, добавляем их в таблицу измерений модуля
      if (newEntities.length > 0) {
        updateMeasurements(this.pmodule.measurements, newEntities);
      }
    }
  }

  async created() {
    if (this.pmodule.nodes && this.pmodule.nodes.length) {
      const totalNodeNames: {title: string; value: number}[] = [];
      const nodesIds: number[] = this.pmodule.nodes.map((item, index) => index);

      const getNameNode = async (idx: number) => {
        if (this.pmodule.nodes) {
          const {data} = await nodeModule.edit(this.pmodule.nodes[idx].node_id);
          return {title: data.name, value: data.id ?? 0};
        }
      };

      for (const item of nodesIds) {
        const result = await getNameNode(item);
        if (result) {
          totalNodeNames.push(result);
        }
      }
      this.nodeName = totalNodeNames;
    }
    await this.loadAM(); // подтягиваем АМ программного модуля, если он привязан
    //для тех измерений, которые уже сохранены, проставляем isActive = true и isNew = false
    this.pmodule.measurements.forEach((elem: any) => {
      if (!elem.isNew) {
        elem.isActive = true;
        elem.isNew = false;
      }
    });

    await this.loadMeasurements();
  }

  updateTemperatureModules(jsonString: string) {
    this.pmodule.temperatureModules = jsonString;
    this.onChange();
  }

  updateEnergyModules(jsonString: string) {
    this.pmodule.energyModules = jsonString;
    this.onChange();
  }

  updateTahoModules(jsonString: string) {
    this.pmodule.tahoModules = jsonString;
    this.onChange();
  }

  updateAccelerometerModules(jsonString: string) {
    this.pmodule.accelerometerModules = jsonString;
    this.onChange();
  }

  get cancelChangesDialog() {
    return this.$refs.cancelChangesDialog as any;
  }

  back() {
    // если были внесены изменения на форме
    if (this.changed) {
      this.cancelChangesDialog.open('/modules');
    } else router.push('/modules');
  }
}
